import comp from "./NoDataComponent";
export default comp;
